import React from 'react';

import {
  Redirect,
} from 'react-router-dom';

import {
  investmentsUrl,
} from '../links';

const Redirects = () => {
  return (
    <React.Fragment>
      <Redirect
        from="/investor-dashboard"
        to={investmentsUrl}
      />
    </React.Fragment>
  );
};

export default Redirects;
